module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/competitions/competitions.component.css
// module id = ./src/app/components/competitions/competitions.component.css
// module chunks = main